import React from 'react';
import PropTypes from 'prop-types';

import { ProgressBar } from 'react-bootstrap';

class CompletionList extends React.Component {

	render() {
		let user = this.props.user;

		let prof_pic = {
			name : 'Profile Picture',
			data : user.profile_picture != null
		}
		let avatar = {
			name : 'Avatar',
			data : user.avatar != null
		}
		let address = {
			name : 'Address',
			data : !(Object.keys(user.address).length < 5)
		}
		let phone = {
			name : 'Phone Number',
			data : !(!user.personal_phone)
		}
		let company = {
			name : 'Company', 
			data : !(!user.company_name)
		}
		let logo = {
			name : 'Company Logo',
			data : user.logo != null
		}

		let list = [prof_pic, avatar, address, phone, company, logo];

		// Compute 'now' prop for ProgressBar
		let progress = 0;
		list.forEach(item => {
			if(item.data)
				progress = progress + parseInt(100 / list.length)
		})

		return (
			<div className='completion-list-container'>
        <h6>Profile Completion</h6>
				<div className='row'>
					<div className='col-md-12'>
						<ProgressBar now={progress}/>
							{list.map((item, index) => {
								if(!item.data)
									return (
										<div key={index} className='row'>
											<div className='col-xs-1 visible-xs col-sm-1 visible-sm' />
											<div className='col-md-10 col-xs-10 col-sm-10 col-md-offset-2 unfinished-profile-element'>
												{item.name}
											</div>
										</div>
									)
								else
									return (
										<div key={index} className='row'>
											<div className='col-md-2 col-xs-1 col-sm-1'>
												<div className='fa fa-check' />
											</div>
											<div className='col-md-10 col-xs-10 col-sm-10 finished-profile-element'>
												{item.name}
											</div>
										</div>
									)
							})}
					</div>
				</div>
			</div>
		)
	}
}

export default CompletionList;



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/completionList.js